import React, { useState } from "react";
import { displayLog } from "../common/common";
import { useDispatch } from "react-redux";
import { setLoading } from "../../../redux/actions/DRM_user.action";
import Select from "react-select";
import { axios_tenant } from "../../../../axios";
import "./owner.css";
import PropTypes from "prop-types";
const Owner = (props) => {

  

  const dispatch = useDispatch();
  const [user, setUser] = useState("");
  const [selectedOption, setSelectedOption] = useState(null);

  if (!props.show) {
    return null;
  }

  const register = async () => {
    dispatch(setLoading(true));

    let req = {
      email: user.toLowerCase(),
      roll: selectedOption.value,
    };

    let response = await axios_tenant.post("/users/sendInvitation", req).then((res) => res.data);
    if (response?.success) {
      displayLog("Invite link sent", "success");
    } else {
      displayLog(response.message, "error");
    }
    //
    dispatch(setLoading(false));
    props.onCall();
    props.onClose();
    // axios
    //   .post("http://localhost:4000/users/owner", {
    //     email: user,
    //     roll: selectedOption.value,
    //   })
    //   .then((response) => {
    //     if (response.status === 200) {
    //       alert("Invite link sent");

    //       navigate("/login");
    //     }
    //   });
  };

  const options = [
    { value: "user", label: "User" },
    { value: "admin", label: "Admin" },
  ];
  return (
    <div className="mod">
      <div className="mod-content container" /*style={HeaderStyle}*/>
        <div className="d-flex justify-content-between m-2 mt-3">
          <h4>Invite User</h4>
          {/* <button onClick={props.onClose}>X</button> */}
          <i
            className="fa-solid fa-xmark"
            role="button"
            tabIndex={0}
            onClick={props.onClose}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                props.onClose();
              }
            }}
          ></i>
        </div>
        <form action="" className="container">
          <div>
          <label htmlFor="username">Email Address</label>
          <br />
          <input
            id="username"
            type="text"
            name="username"
            className="owner_input p-1 ps-2"
            required
            onChange={(e) => {
              setUser(e.target.value);
            }}
          />
          </div>
          <div>
        <label htmlFor="role">Role</label>
        <br />
        <Select
          inputId="role"
          className="owner_select"
          defaultValue={selectedOption}
          onChange={setSelectedOption}
          options={options}
        />
          </div>

          <div className="text-center m-3">
            <button
              id="sub_btn"
              type="submit"
              className="btn default-theme-btn"
              onClick={(e) => {
                e.preventDefault();
                register();
              }}
            >
              Invite
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};
Owner.propTypes = {
  show: PropTypes.bool.isRequired,
  onCall: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};
export default Owner;